module.exports = __webpack_public_path__ + "img/xp5_003.7bb17582.jpg";